<template>
    <div class="page white_bg">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="marginT24 generalPagePaddingH" style="padding-bottom: 34px">
                <form class="form infoForm font14r" action="javascript:;" @submit="save()">
                    <div class="form_row clearfix">
                        <div class="fl">
                            <label class="block formLabel">上传头像</label>
                            <div class="font10r" style="color: #B1B4B9">*点击头像框可上传头像</div>
                        </div>
                        <div class="fr">

                            <headImageSelector v-model="dataItem.headImage" />

                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">主办方名称</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="text" placeholder="填写主办方名称"
                               v-model="dataItem.name"
                            />
                        </div>
                    </div>

                    <div class="form_row">
                        <label class="block formLabel">联系方式</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="text" pattern="[+0-9]+"
                               title="电话号码（不能有括号、空格）" placeholder="填写主办方的联系方式" v-model="dataItem.phone"
                            />
                        </div>
                    </div>
                    <div class="form_row">
                        <label class="block formLabel">联系邮箱</label>
                        <div class="marginT12">
                            <input class="inputbox noOutline font14r" type="email" placeholder="填写最常用的邮箱"
                               v-model="dataItem.email"
                            />
                        </div>
                    </div>

                    <div class="form_row">
                        <label class="block formLabel">主办方地址</label>
                        <div class="marginT12">

                            <threeLevelAreaSelector v-model="areas"/>

                            <input class="inputbox block w100p noOutline font14r marginT8" type="text" placeholder="填写主办方所在真实地址"
                                   v-model="dataItem.addr"
                            />
                        </div>
                    </div>

                    <div class="form_row">
                        <label class="block formLabel">主办方简介</label>
                        <div class="marginT12">
                            <textarea class="inputbox block noOutline font14r" placeholder="填写主办方的简介"
                                style="width: 100%; min-height: 44px;" v-model="dataItem.introduce"
                            />
                        </div>
                    </div>

                    <div class="form_row" style="border-bottom: none;">
                        <label class="block formLabel">主办方风采</label>
                        <div class="marginT12 imageList clearfix">

                            <imageListSelector v-model="dataItem.imgList" :maxLength="3" />

                        </div>
                    </div>

                    <div style="height: 86px;">
                        <div class="optArea fixedBottom white_bg" style="height: 86px;">
                            <div class="generalPagePaddingH flexLayout" style="padding-top: 5px;">
                                <div class="flexItem" style="margin-right: 13px">
                                    <button class="button block cancelButton" type="button" style="border-radius: 20px;
                                    height: 42px; line-height: 42px; background: #e7e7e7; color: black">
                                        取消
                                    </button>
                                </div>
                                <div class="flexItem">
                                    <button class="button block white" type="submit" style="border-radius: 20px;
                                    height: 42px; line-height: 42px; background: #ffbc3b; "
                                        :disabled="!dataItem || !dataItem.name">保存设置</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import threeLevelAreaSelector from '@/components/threeLevelAreaSelector';
import imageListSelector from '../../../components/imageListSelector';
import headImageSelector from '../../../components/headImageSelector';

// data
import citiesData from '@data/cities_v2.json'

// util
import appHelper from '@/util/appHelper';

const config = {
    apiConfig : {
        get : {
            url : 'portal/underline/v2/sponsor/get'
        },
        update : {
            url : 'portal/underline/v2/sponsor/update',
            method : 'PUT'
        },
    }
};

export default {
    name: "underlineCourseSponsorEditProfile",
    extends : shixunPagePart,
    components : {
        threeLevelAreaSelector,
        imageListSelector,
        headImageSelector
    },
    data () {
        return {
            title : '修改资料',
            apiConfig : config.apiConfig,
            enableDataItem: true,
            autoLoadDataItem: true,
            dataItem: {
                headImage: "",
                name: "",
                addr: "",
                province: "",
                city: "",
                area: "",
                address: "",
                phone: "",
                email: "",
                introduce: "",
                imgList : []
            },
            citiesData : citiesData,
            areas : ['', '', ''],
            selectedProvince : null,
            selectedCity : null
        }
    },
    methods : {
        onLoadDataItem() {
            this.areas = [
                this.dataItem.province,
                this.dataItem.city,
                this.dataItem.area,
            ];
        },
        beforeSubmit(data) {
            data.imgs = JSON.stringify(data.imgList);
            data.province = this.areas[0];
            data.city = this.areas[1];
            data.area = this.areas[2];
            delete data.imgList;
            delete data.jobList;
            delete data.seekerList;
            return data;
        },

        onSubmitSuccess() {
            appHelper.showHint('保存成功！');
        },

        onSubmitError(error) {
            appHelper.showHint(error.msg);
        },

    }
}
</script>

<style lang="scss" scoped>
.infoForm {

    .form_row {
        padding: 20px 0 10px;
        border-bottom: 1px solid #F0F0F0;
    }
    .formLabel {
        color: #8994A9;
        margin-bottom: 12px;
    }
    .inputbox {
        border: none;
        background: transparent;
        color: #333333;
        font-size: 100%;
    }
    .imageList {
        .imageItem {
            position: relative;
            float: left;
            width: 84px;
            height: 84px;
            background: #F7F7F7;
            border: 1px solid #DFDFE0;
            border-radius: 8px;
            margin: 0 10px 10px 0;
            overflow: hidden;
            .removeButton {
                position: absolute;
                z-index: 1;
                right: 4px;
                top: 4px;

                width: 12px;
                height: 12px;
                line-height: 12px;
                background: rgba(128, 128, 128, 0.7);
                border-radius: 50%;
                text-align: center;
                color: white;
            }

            .greyPlusIcon {
                position: absolute;
                z-index: 1;
                left: 50%;
                top: 50%;
                margin-left: -17px;
                margin-top: -17px;
                width: 34px;
                height: 34px;
            }
        }

    }
}
.areaSelect {
    min-width: 63px;
    height: 28px;
    line-height: 28px;
    background: #FCF9F9;
    border: 1px solid #D9D9D9;
    outline: none;
    padding: 0 1em;

    border-radius: 4px;
    appearance: none; /* 去掉默认图标 */
    margin: 0 5px;
    text-align: center;
    font-weight: bold;
}
</style>
